import script from "./AllProductByCat.vue?vue&type=script&setup=true&lang=js"
export * from "./AllProductByCat.vue?vue&type=script&setup=true&lang=js"

import "./AllProductByCat.vue?vue&type=style&index=0&id=d3f5cb66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3f5cb66"]])

export default __exports__